// src/utils/stripePromise.ts
import { loadStripe } from '@stripe/stripe-js';

// Sustituye esta clave con tu clave pública real desde el dashboard de Stripe
export const stripePromise = loadStripe('pk_test_51RCR2EQ8TXhjvJp9CWsBdAIr777XFLI0suXBcwqrb9okbr9SNXGabqmYTCHmqMzEZYjbUacCCxUmF6B7zaGHd4b000tJxJR8vw');
